/**
 * A share link as the QR dialog prints it under the code (kitecorp/transferify-ui#3320): without its scheme, which
 * every browser fills in and which only pushes the part a reader checks, the host and the transfer, into the
 * ellipsis. The QR itself encodes the whole link.
 */
export function shareLinkLabel(url: string): string {
	return url.replace(/^https?:\/\//, "");
}
